// extracted by mini-css-extract-plugin
export default {"GameStart":"Title_GameStart__zGoSP","GameOver":"Title_GameOver__Oj6sa","GameWon":"Title_GameWon__g8sV0","general":"Title_general__6X0gS"};